module.exports = __webpack_public_path__ + "static/media/janifer.ce173111.jpg";